/* SIDDAMENT infinite scroll v8 — simple & reliable
 * Sentinel (below the grid) enters view -> fetch next page -> append items.
 * One thing at a time. Observer re-observes after each append.
 * Pagination stays visible unless this script confirms it's working (adds
 * `html.sidd-infinite-ready`), so any breakage falls back to normal paging.
 *
 * v8 (2026-10-31): burst mode. The theme's sidd-oos-demote block hides
 * sold-out cards until every page is in, so a mostly sold-out collection
 * (NEXT RESTOCKKKKK: 254 of 255) showed an empty grid while 8 pages loaded
 * one by one (~11 s on the warehouse line). When fewer than BURST_BELOW
 * cards are visible, the remaining pages are fetched in parallel and
 * appended in page order. Each page fetch also retries before giving up.
 *
 * Debug: append ?sidd_debug=1 to the URL.
 */
(function () {
  if (window.__siddInfiniteScrollLoaded) return;
  window.__siddInfiniteScrollLoaded = true;

  var DEBUG = /[?&]sidd_debug=1/.test(location.search);
  var FETCH_MARGIN = 1600;
  var BURST_BELOW = 12;     // visible cards under this -> fetch the rest in parallel
  var BURST_MAX_PAGES = 12; // never burst more pages than this (big collections stay lazy)
  var BURST_PARALLEL = 6;
  var RETRY_DELAYS = [600, 1800];
  var log = DEBUG ? function () { console.log.apply(console, ['[infinite]'].concat([].slice.call(arguments))); } : function () {};

  var state = null;
  window.__siddInfinite = function () { return state; }; // for debugging

  function init() {
    teardown();
    // On collection pages #product-grid IS the <ul>; on the search page it's a
    // wrapper <div> around an id-less <ul class="product-grid">. Items must be
    // appended to the <ul> or they land outside the grid and stack full-width.
    var gridRoot = document.getElementById('product-grid');
    var grid = gridRoot && (gridRoot.tagName === 'UL' ? gridRoot : gridRoot.querySelector('ul.product-grid'));
    var wrapper = document.querySelector('.pagination-wrapper[data-next-url]');
    if (!grid || !wrapper) { log('no grid or no next page'); return; }

    document.documentElement.classList.add('sidd-infinite-ready');

    var sentinel = document.createElement('span');
    sentinel.className = 'infinite-scroll-sentinel';
    sentinel.textContent = '\u200B';
    sentinel.style.cssText = 'display:block !important;width:100%;height:1px;pointer-events:none;visibility:hidden;';
    wrapper.parentNode.insertBefore(sentinel, wrapper);

    state = { grid: grid, wrapper: wrapper, sentinel: sentinel, loading: false, observer: null };
    log('init, next=', wrapper.getAttribute('data-next-url'));

    arm();
  }

  function arm() {
    if (!state) return;
    if (!state.observer) {
      state.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) load(); });
      }, { rootMargin: FETCH_MARGIN + 'px 0px' });
    }
    state.observer.observe(state.sentinel);

    // Belt-and-suspenders: listen to scroll too. IntersectionObserver is
    // supposed to suffice, but it's been flaky on some Chrome versions /
    // when the tab is backgrounded. Scroll handler fires only when close
    // to the bottom; cheap.
    if (!state.scrollHandler) {
      state.scrollHandler = function () {
        if (!state || state.loading) return;
        var r = state.sentinel.getBoundingClientRect();
        if (r.top < window.innerHeight + FETCH_MARGIN) load();
      };
      window.addEventListener('scroll', state.scrollHandler, { passive: true });
    }

    // And poll it. When sidd-oos-demote hides a page of sold-out cards the
    // sentinel jumps up with no scroll, and the observer can miss that
    // (backgrounded tab, no render), leaving an empty grid that never loads.
    if (!state.poll) state.poll = setInterval(state.scrollHandler, 400);

    // Immediate check — if the sentinel is already in range at arm time
    // (e.g. on a short collection or after append that leaves us already
    // near the bottom), kick the first fetch.
    var r = state.sentinel.getBoundingClientRect();
    if (r.top < window.innerHeight + FETCH_MARGIN) {
      setTimeout(load, 50);
    }
    log('armed, sentinel rect.top=', r.top);
  }

  function load() {
    if (!state || state.loading) return;
    var nextUrl = state.wrapper.getAttribute('data-next-url');
    if (!nextUrl) { log('no next url, done'); teardown(); return; }
    var urls = burstUrls(nextUrl);
    if (urls) { burst(urls); return; }
    state.loading = true;
    state.observer.disconnect();
    log('fetching', nextUrl);

    var s = state;
    getPage(nextUrl)
      .then(function (html) {
        if (state !== s) return;
        appendPage(html);
      })
      .catch(function (err) {
        console.error('[infinite] fetch failed', err);
        if (state === s) fail();
      })
      .then(function () { if (state === s) settle(); });
  }

  // Burst only when the grid looks empty (every card so far hidden, or
  // nearly), and the pager says how many pages are left.
  function burstUrls(nextUrl) {
    var visible = 0;
    Array.prototype.forEach.call(state.grid.children, function (li) {
      if (li.getClientRects().length) visible++;
    });
    if (visible >= BURST_BELOW) return null;
    var m = nextUrl.match(/[?&]page=(\d+)/);
    if (!m) return null;
    var first = +m[1], last = first;
    Array.prototype.forEach.call(state.wrapper.querySelectorAll('a[href*="page="]'), function (a) {
      var p = a.getAttribute('href').match(/[?&]page=(\d+)/);
      if (p && +p[1] > last) last = +p[1];
    });
    if (last === first || last - first + 1 > BURST_MAX_PAGES) return null;
    var urls = [];
    for (var p = first; p <= last; p++) urls.push(nextUrl.replace(/([?&])page=\d+/, '$1page=' + p));
    log('burst', visible, 'visible, pages', first, '-', last);
    return urls;
  }

  // Fetch every page at once (BURST_PARALLEL at a time) and append them in
  // page order as each one's turn comes. data-next-url always names the first
  // page not yet appended, so sidd-oos-demote keeps hiding until the end.
  function burst(urls) {
    var s = state;
    s.loading = true;
    s.observer.disconnect();
    var pages = new Array(urls.length), started = 0, flushed = 0, broken = false;

    return new Promise(function (done) {
      function flush() {
        while (state === s && !broken && flushed < urls.length && pages[flushed] !== undefined) {
          appendPage(pages[flushed]);
          pages[flushed] = null;
          flushed++;
        }
        if (state !== s || broken || flushed === urls.length) done();
      }
      function next() {
        if (state !== s || broken || started >= urls.length) return;
        var i = started++;
        getPage(urls[i])
          .then(function (html) { pages[i] = html; flush(); next(); })
          .catch(function (err) {
            if (broken) return;
            broken = true;
            console.error('[infinite] burst fetch failed', urls[i], err);
            if (state === s) fail();
            done();
          });
      }
      for (var k = 0; k < BURST_PARALLEL; k++) next();
    }).then(function () { if (state === s) settle(); });
  }

  function getPage(url) {
    var attempt = 0;
    function go() {
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .catch(function (err) {
          if (attempt >= RETRY_DELAYS.length) throw err;
          var wait = RETRY_DELAYS[attempt++];
          log('retry', url, 'in', wait, 'ms', err);
          return new Promise(function (res) { setTimeout(res, wait); }).then(go);
        });
    }
    return go();
  }

  function appendPage(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.getElementById('product-grid');
    var newWrapper = doc.querySelector('.pagination-wrapper');
    if (!newGrid) { log('response missing #product-grid'); return; }
    var items = [].slice.call(newGrid.querySelectorAll('li.grid__item'));
    log('got', items.length, 'items');

    items.forEach(function (li) {
      [li].concat([].slice.call(li.querySelectorAll('.scroll-trigger, .animate--slide-in, [data-cascade]')))
        .forEach(function (el) {
          el.classList.remove('scroll-trigger', 'animate--slide-in');
          el.removeAttribute('data-cascade');
          el.style.removeProperty('--animation-order');
        });
    });

    var frag = document.createDocumentFragment();
    items.forEach(function (li) { frag.appendChild(li); });

    // Append synchronously — NOT inside requestAnimationFrame. Chrome
    // suspends rAF in hidden/background tabs while scroll + setTimeout
    // fallbacks keep firing, so a rAF-deferred append let the loop fetch
    // every remaining page with nothing ever appended (and the stale
    // next-url refetched the same page). One fragment append is a single
    // reflow anyway.
    state.grid.appendChild(frag);
    state.grid.dispatchEvent(new CustomEvent('siddament:products-appended', { bubbles: true, detail: { count: items.length } }));
    log('appended', items.length, 'total now:', state.grid.children.length);

    var next = newWrapper && newWrapper.getAttribute('data-next-url');
    if (next) {
      state.wrapper.setAttribute('data-next-url', next);
    } else {
      state.wrapper.removeAttribute('data-next-url');
    }
  }

  function settle() {
    if (!state) return;
    state.loading = false;
    if (state.wrapper.getAttribute('data-next-url')) {
      arm();
    } else {
      teardown();
    }
  }

  function fail() {
    document.documentElement.classList.remove('sidd-infinite-ready');
    teardown();
  }

  function teardown() {
    if (!state) return;
    if (state.observer) state.observer.disconnect();
    if (state.scrollHandler) window.removeEventListener('scroll', state.scrollHandler);
    if (state.poll) clearInterval(state.poll);
    if (state.sentinel && state.sentinel.parentNode) state.sentinel.parentNode.removeChild(state.sentinel);
    state = null;
  }

  function watchFacets() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !window.MutationObserver) return;
    new MutationObserver(function () {
      document.documentElement.classList.remove('sidd-infinite-ready');
      setTimeout(init, 30);
    }).observe(container, { childList: true, subtree: false });
  }

  function boot() {
    try { init(); watchFacets(); } catch (e) { console.error('[infinite] init crashed', e); fail(); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
